export enum MetaRouterCustomTrackingEvents {
    PAGE_LOADED = "page_loaded",
    SIGNED_UP = "signed_up",
    SIGNED_IN = "signed_in",
    NEWSLETTER_SUBSCRIBED = "newsletter_subscribed",
    PRODUCT_REMOVED = "product_removed",
    PRODUCT_ADDED = "product_added",
    CART_VIEWED = "cart_viewed",
    CHECKOUT_STARTED = "checkout_started",
    SHIPPING_INFO_ENTERED = "shipping_info_entered",
    BILLING_INFO_ENTERED = "billing_info_entered",
    PAYMENT_INFO_ENTERED = "payment_info_entered",
    CHECKOUT_STEP_COMPLETED = "checkout_step_completed",
    PRODUCT_VIEWED = "product_viewed",
    PERSONALIZATION = "personalization",
    GIFT_WRAPPING_PRODUCT_ADDED = "gift_wrapping_product_added",
    ORDER_COMPLETED = "order_completed",
    PRODUCTS_SEARCHED = "products_searched",
    REMIND_ME = "remind_me",
    PAGE_ERROR = "page_error",
}
export enum GoogleDataLayerEvents {
    PAGE_LOADED = "page_loaded",
    SIGN_UP="sign_up",
    LOGIN="login",
    NEWSLETTER_SUBSCRIBED = "newsletter_subscribed",
    SEARCH="search",
    VIEW_ITEM="view_item",
    ADD_TO_CART="add_to_cart",
    REMOVE_FROM_CART="remove_from_cart",
    VIEW_CART="view_cart",
    BEGIN_CHECKOUT="begin_checkout",
    ADD_SHIPPING_INFO="add_shipping_info",
    ADD_PAYMENT_INFO="add_payment_info",
    CHECKOUT_STEP_COMPLETED = "checkout_step_completed",
    PURCHASE="purchase",
    REMIND_ME = "remind_me",
    PAGE_ERROR = "page_error",
}

export interface OriginalProductFormat {
  name?: string;
  id?: number | string;
  collection?: string;
  category?: [string, string];
  brand?: string;
  variant?: string;
  regularPrice?: number;
  link?: string;
  specialPrice?: number;
}

export interface ProductAnalyticsFormat {
    item_name: string;
    item_id: number | string;
    collection: string;
    item_category: string;
    item_category2: string;
    item_brand: string;
    item_variant: string;
    price: number;
    currency?: string;
    product_url: string;
    discount: number;
}

export interface PageLoadedData {
    page_name: string;
    page_url: string;
    referring_url: string;
    language: string;
    country: string;
    user_id: string;
    logged_in: string;
    page_type?: string;
}

export enum AttemptType {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE"
}
export interface AttemptAndUserIdData {
    attempt: AttemptType;
    user_id: string;
}

export interface ProductAndCurrencyData extends ProductAnalyticsFormat {
    currency: string,
}

export enum CartType {
    MINI_CART = "miniCart",
    CART_PAGE = "cartPage"
}

export enum AnalyticsCartActions {
    ADD = "add",
    REMOVE = "remove",
}
export interface CartViewedData {
    value: number,
    items: ProductAnalyticsFormat[],
    cartType: CartType,
    currency: string,
}

export interface CheckoutStartedData {
    currency: string,
    value: number,
    coupon: string,
    items: ProductAnalyticsFormat[],
}

export interface ShippingInfoEnteredData {
    currency: string,
    value: number,
    coupon: string,
    delivery_method: any,
    items: ProductAnalyticsFormat[],
}

export enum PaymentType {
    SCHEME = "scheme",
    CREDIT_CARD = "credit_card",
    PAYPAL = "paypal",
    APPLE_PAY = "apple_pay",
    GOOGLE_PAY = "google_pay",
    KLARNA = "klarna",
    IDEAL = "ideal",
    BANCONTACT = "bancontact",
    GIROPAY = "giropay",
    EPS = "eps",
}
export interface PaymentInfoEnteredData {
    currency: string,
    value: number,
    coupon: string,
    payment_type: PaymentType | any,
    items: ProductAnalyticsFormat[],
}

export interface CheckoutStepCompletedData {
    step_number: number,
    step_name: string,
}

export interface OrderCompletedData {
    transaction_id: string,
    value: number,
    tax: number,
    shipping: string|number,
    currency: string,
    coupon: string,
    items: ProductAnalyticsFormat[],
}

export interface ProductsSearchedData {
    search_term: string,
    search_results: any
}

export interface RemindMeData {
    product_name: string,
    sku: string,
    product_category: string,
    brand: string,
    variant: string,
    price: number,
    product_url: string,
    discount: number,
}

export interface PageErrorData {
    error_type: number,
    page_url: string,
}
